import { ArrowLeftOutlined, HomeOutlined } from "@ant-design/icons";
import { Result, Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

const NotAuthorized = () => {
  const { push, goBack } = useHistory();
  const { t } = useTranslation();
  return (
    <Result
      status="403"
      title="403"
      subTitle={t("common.errors.403")}
      extra={[
        <Button
          icon={<ArrowLeftOutlined />}
          type="default"
          onClick={goBack}
          key="back"
        >
          {t("common.back")}
        </Button>,
        <Button
          icon={<HomeOutlined />}
          type="default"
          onClick={() => {
            push("/");
          }}
          key="home"
        >
          {t("common.home")}
        </Button>,
      ]}
    />
  );
};

export default NotAuthorized;
